var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":"8"}},[_c('view-component',{attrs:{"model_name":"salon"},scopedSlots:_vm._u([{key:"mapa",fn:function(data){return [_c('salon',{attrs:{"modo":"editar","salon":_vm.salon}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }